import React from 'react';
import styled from 'styled-components';
import { cssSpacing, titleMedium, Text, titleSmall, IconPlay, screenXxsMax, screenXsMax, screenSmMax, screenMdMin, cssColorValue, KeyboardDetectionProvider, } from '@spotify-internal/encore-web';
import { ContentfulImage } from '../../ui';
import { transformScaleUp } from '../../ui/utils';
import { Grid } from '../../ui';
import { ImageWrapper } from '../../ui';
import { useFrodorModules } from '../../Context/FrodorModulesProvider';
const RelatedStoriesList = styled(Grid) `
  background: ${cssColorValue('backgroundBase')};
  color: ${cssColorValue('textBase')};
  padding-top: ${cssSpacing('looser-4')};
  padding-bottom: ${cssSpacing('looser-4')};
  @media (max-width: ${screenXsMax}) {
    padding: ${cssSpacing('base')};
    ${cssSpacing('base')}
    ${cssSpacing('looser-4')};
  }
`;
const StyledSupertext = styled.div `
  grid-column: 1/-1;
  padding-bottom: ${cssSpacing('looser-4')};
  ${titleMedium}

  @media (max-width: ${screenXxsMax}) {
    padding: ${cssSpacing('base')} 0;
  }
`;
const ItemWrapper = styled.a `
  text-decoration: none;
  grid-column: 1/-1;
  display: flex;
  flex-direction: row;
  padding-bottom: ${cssSpacing('tighter-4')};

  :last-child {
    padding-bottom: 0;
  }

  @media (max-width: ${screenXxsMax}) {
    padding-bottom: ${cssSpacing('base')};
  }

  &:hover {
    .title {
      text-decoration: underline;
    }
    img {
      ${transformScaleUp};
      transition: transform 0.3s ease-in-out;
    }
    svg {
      ${transformScaleUp};
      transition: transform 0.3s ease-in-out;
      opacity: 0.8;
    }
  }
`;
const Item = ({ component, children, ...rest }) => {
    return (React.createElement(ItemWrapper, { as: component, ...rest }, children));
};
const Title = styled(Text).attrs({
    variant: 'titleMedium',
}) `
  margin-bottom: ${cssSpacing('base')};
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media (max-width: ${screenSmMax}) {
    -webkit-line-clamp: 2;
  }
  @media (max-width: ${screenXxsMax}) {
    ${titleSmall}
  }
`;
const Description = styled(Text).attrs({
    variant: 'titleSmall',
}) `
  max-height: ${cssSpacing('looser-4')};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 18px;

  @media (max-width: ${screenSmMax}) {
    display: none;
  }
`;
const ImageContainer = styled(ImageWrapper) `
  width: 20%;
  height: unset;
  overflow: hidden;

  @media (max-width: ${screenMdMin}) {
    width: 40%;
  }

  @media (max-width: ${screenXxsMax}) {
    width: 35%;

    svg {
      height: ${cssSpacing('base')};
      width: ${cssSpacing('base')};
      bottom: ${cssSpacing('tighter-4')};
      left: ${cssSpacing('tighter-4')};
    }
  }
`;
const TextWrapper = styled.div `
  padding-left: ${cssSpacing('looser-4')};
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${cssColorValue('textBase')};

  @media (max-width: ${screenMdMin}) {
    padding-left: ${cssSpacing('base')};
    width: 55%;
  }

  @media (max-width: ${screenXxsMax}) {
    padding-left: ${cssSpacing('tighter-2')};
    width: 55%;
  }
`;
const TRACK_CAT = 'module-relatedStoriesModule';
export const RelatedStoriesListModule = React.forwardRef(({ headline = '', items = [] }, ref) => {
    const { InteractiveElement } = useFrodorModules();
    const relatedStories = items.filter(Boolean);
    return (React.createElement(KeyboardDetectionProvider, null, (relatedStories === null || relatedStories === void 0 ? void 0 : relatedStories.length) ? (React.createElement(RelatedStoriesList, { ref: ref },
        React.createElement(StyledSupertext, null, headline),
        relatedStories.map((item, index) => (React.createElement(InteractiveElement, { customComponent: Item, trackingCategory: TRACK_CAT, trackingLabel: "Related Stories", href: item.url, key: `link-${item.id}-${index}` },
            React.createElement(ImageContainer, { video: item.contentType === 'videoPage', featured: false }, item.image && (React.createElement(ContentfulImage, { asset: item.image },
                React.createElement(IconPlay, { "aria-hidden": true })))),
            React.createElement(TextWrapper, { key: `text-${item.id}-${index}` },
                React.createElement(Title, { className: "title" }, item.title),
                React.createElement(Description, null, item.description))))))) : null));
});
